import { render } from "./Navigator.vue?vue&type=template&id=6ddc050a&scoped=true&ts=true"
import script from "./Navigator.vue?vue&type=script&lang=ts"
export * from "./Navigator.vue?vue&type=script&lang=ts"

import "./Navigator.vue?vue&type=style&index=0&id=6ddc050a&lang=scss&scoped=true"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddc050a"]])

export default __exports__